import React from 'react';
import PropTypes from 'prop-types';
import Button from 'partial/components/Button';

/*
 * Kept as a thin shim over Button so its 22 call sites don't churn. It used to
 * carry a parallel 7-colour map (one of which, `link`, wasn't even in it and
 * silently rendered unstyled).
 */
const AS_VARIANT = {
  outline: { outline: true },
  primary: { primary: true },
  success: { primary: true },
  danger: { danger: true },
  link: { link: true },
  default: { primary: true },
};

const AsyncButton = ({
  spinnerContainerClassName,
  spinnerClassName,
  className,
  isLoading,
  children,
  color,
  ...otherProps
}) => (
  <Button
    isLoading={isLoading}
    className={className}
    {...(AS_VARIANT[color] || AS_VARIANT.default)}
    {...otherProps}
  >
    {children}
  </Button>
);

AsyncButton.defaultProps = {
  color: 'default',
  className: '',
  spinnerClassName: '',
  spinnerContainerClassName: '',
  isLoading: false,
};

AsyncButton.propTypes = {
  color: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  spinnerClassName: PropTypes.string,
  spinnerContainerClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AsyncButton;
